'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var get = _interopDefault(require('lodash/get'));
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
var sharedComponents = require('../shared-components.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  appearance: none;\n  background-color: ", ";\n  padding: 5px 30px 5px 15px;\n  width: 100%;\n  height: 40px;\n  color: ", ";\n  border: solid 1px ", ";\n  border-radius: 0px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: ", ";\n  cursor: pointer;\n\n  option:not(:first-child):enabled {\n    color: ", ";\n  }\n\n  ::-ms-expand {\n    display: none;\n  }\n\n  :active,\n  :focus {\n    border-color: ", ";\n    outline: none;\n  }\n\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  text-overflow: ellipsis;\n  appearance: none;\n  background-color: ", ";\n  padding: 5px 30px 5px 15px;\n  width: 100%;\n  height: 40px;\n  color: ", ";\n  border: solid 1px ", ";\n  border-radius: 0px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: ", ";\n  cursor: pointer;\n\n  option:not(:first-child):enabled {\n    color: ", ";\n  }\n\n  ::-ms-expand {\n    display: none;\n  }\n\n  :active,\n  :focus {\n    border-color: ", ";\n    outline: none;\n  }\n\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n  color: ", ";\n  i {\n    font-size: 28px;\n    position: absolute;\n    right: 16px;\n    top: 8px;\n    pointer-events: none;\n  }\n  .default-val {\n    display: none;\n  }\n  :active,\n  :focus {\n    outline: none;\n  }\n  ", ":active + i, ", ":focus + i {\n    color: ", ";\n    outline: none;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n  color: ", ";\n  i {\n    font-size: 28px;\n    position: absolute;\n    right: 16px;\n    top: 8px;\n    pointer-events: none;\n  }\n  .default-val {\n    display: none;\n  }\n  :active,\n  :focus {\n    outline: none;\n  }\n  ", ":active + i, ", ":focus + i {\n    color: ", ";\n    outline: none;\n  }\n"]);

function getBgColor(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error;

  if (disabled) {
    return settings.COLOR.bgGrey;
  }
  if (error) {
    return settings.COLOR.lightSoftRed;
  }
  return settings.COLOR.white;
}

function getItemColor(_ref2) {
  var disabled = _ref2.disabled,
      error = _ref2.error;

  if (disabled) {
    return settings.COLOR.lineGray;
  }
  if (error) {
    return settings.COLOR.softRed;
  }
  return settings.COLOR.darkGray;
}

var StyledSelect = styled__default.select(_templateObject, function (props) {
  return getBgColor(props);
}, function (props) {
  return props.placeholderColor ? settings.COLOR.lightGray : settings.COLOR.textBlack;
}, function (props) {
  return props.error ? settings.COLOR.softRed : settings.COLOR.lineGray;
}, function (props) {
  return props.fontSize || "16px";
}, settings.COLOR.textBlack, function (props) {
  return props.disabled ? settings.COLOR.lineGray : settings.COLOR.brightBlue;
}, settings.COLOR.lightGray);
/* stylelint-disable selector-type-no-unknown */
var StyledSelectDropdown = styled__default(function (_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      placeholder = _ref3.placeholder,
      rest = _babelHelpers.objectWithoutProperties(_ref3, ["className", "children", "placeholder"]);
  return React__default.createElement(
    "div",
    { className: className },
    React__default.createElement(
      StyledSelect,
      rest,
      placeholder && renderDisabledOption(placeholder),
      children
    ),
    React__default.createElement("i", { className: "fal fa-angle-down" })
  );
})(_templateObject2, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.height || "40px";
}, function (props) {
  return getItemColor(props);
}, StyledSelect, StyledSelect, function (props) {
  return props.disabled ? settings.COLOR.lineGray : settings.COLOR.brightBlue;
});
var renderDisabledOption = function renderDisabledOption(prop) {
  return React__default.createElement(
    "option",
    { disabled: true, key: "option-" + prop.value, value: prop.value },
    prop.label
  );
};

var SelectDropdown = function (_Component) {
  _babelHelpers.inherits(SelectDropdown, _Component);

  function SelectDropdown(props) {
    _babelHelpers.classCallCheck(this, SelectDropdown);

    var _this = _babelHelpers.possibleConstructorReturn(this, (SelectDropdown.__proto__ || Object.getPrototypeOf(SelectDropdown)).call(this));

    _this.state = {
      placeholderColor: !get(props, "value", "")
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(SelectDropdown, [{
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;

      onChange(event.target.value);
      if (event.target.value) {
        this.setState({
          placeholderColor: false
        });
      } else {
        this.setState({
          placeholderColor: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          mb = _props.mb,
          textColor = _props.textColor,
          labelStyle = _props.labelStyle,
          disabled = _props.disabled,
          isRequired = _props.isRequired,
          label = _props.label,
          error = _props.error,
          ErrorMessageStyle = _props.ErrorMessageStyle,
          placeholder = _props.placeholder,
          options = _props.options,
          rest = _babelHelpers.objectWithoutProperties(_props, ["children", "mb", "textColor", "labelStyle", "disabled", "isRequired", "label", "error", "ErrorMessageStyle", "placeholder", "options"]);
      var placeholderColor = this.state.placeholderColor;

      return React__default.createElement(
        sharedComponents.InputGroup,
        { mb: mb },
        React__default.createElement(
          sharedComponents.StyledLabel,
          {
            textColor: textColor,
            labelStyle: labelStyle,
            disabled: disabled },
          label,
          isRequired && React__default.createElement(
            sharedComponents.RedText,
            { disabled: disabled },
            " *"
          )
        ),
        React__default.createElement(
          StyledSelectDropdown,
          _babelHelpers._extends({}, rest, {
            placeholderColor: placeholderColor && placeholder,
            placeholder: placeholder,
            error: error,
            disabled: disabled,
            onChange: this.handleChange }),
          options && options.map(function (opt) {
            return React__default.createElement(
              "option",
              {
                selected: opt.selected,
                disabled: opt.disabled,
                key: "option-" + opt.value,
                value: opt.value },
              opt.label
            );
          }),
          children
        ),
        error && React__default.createElement(
          sharedComponents.ErrorMessage,
          { ErrorMessageStyle: ErrorMessageStyle },
          error
        )
      );
    }
  }]);
  return SelectDropdown;
}(React.Component);

SelectDropdown.propTypes = {
  /** component id */
  id: PropTypes.string.isRequired,
  /** indicator to display red sign */
  isRequired: PropTypes.bool,
  /** text to display */
  label: PropTypes.string,
  /** indicator to display disable dropdown */
  disabled: PropTypes.bool,
  /** error message to display under dropdown */
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** dropdown width */
  width: PropTypes.string,
  /** dropdown height */
  height: PropTypes.string,
  /** text color of label */
  textColor: PropTypes.string,
  /** style to override label component */
  labelStyle: PropTypes.object,
  /** style to override error message component */
  ErrorMessageStyle: PropTypes.object,
  /** list of dropdown options */
  options: PropTypes.array
};
SelectDropdown.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SelectDropdown",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "isRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display red sign"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text to display"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disable dropdown"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "error message to display under dropdown"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "dropdown width"
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "dropdown height"
    },
    "textColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text color of label"
    },
    "labelStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override label component"
    },
    "ErrorMessageStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "style to override error message component"
    },
    "options": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "list of dropdown options"
    }
  }
};

exports.StyledSelect = StyledSelect;
exports.StyledSelectDropdown = StyledSelectDropdown;
exports.default = SelectDropdown;
//# sourceMappingURL=select.js.map
